export default __webpack_public_path__ + "static/media/usb3.a1aceff2.png";